import React from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import '../../App.css';
import { AddOn } from '../AddOn';
import { BookingAddOnDeals } from '../BookingAddOnDeals';
import { BusFareTotal } from '../BusFareTotal';
import { checkIsReschedule, sessionStorageGetItem } from '../Function';
import { ProceedBusFare } from '../ProceedBusFare';
import { Proceed_Departure } from '../Proceed_Departure';
import { Proceed_Return } from '../Proceed_Return';
import { SelectSeatButton } from '../SelectSeatButton';
import { SelectSeatErrorMsg } from '../SelectSeatErrorMsg';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class ProceedComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			// items:[],
			ConversionRate: 0,
			message: '',
			DataisLoaded: false,
		};
	}
	componentDidMount() {
		// const reloadCount = sessionStorageGetItem('reloadCount');
		// if (reloadCount < 2) {
		//     sessionStorageSetItem('reloadCount', String(reloadCount + 1));
		//     window.location.reload();
		// } else {
		//     sessionStorage.removeItem('reloadCount');
		// }
		// fetch(`${SERVER_URL}/eb/get/currency/rate/SGD/MYR`).then(res => res.json()).then(
		// result=>{
		//     this.setState({ConversionRate:result.ConversionRate});
		//     this.setState({message:result.Message});
		//     // console.log(result);
		//     }
		// )

		sessionStorage.removeItem('busFare');
		sessionStorage.removeItem('departBusFare');
		sessionStorage.removeItem('returnBusFare');
		sessionStorage.removeItem('insuranceAddOn');
		sessionStorage.removeItem('healthCareAddOn');
		//remove checkout expiry timestamp
		sessionStorage.removeItem('checkout_expiry_ts');

		// A seat lock (lock_id / return_lock_id) belongs to the specific seats it
		// was reserved for. Entering or returning to the seat-selection page means
		// the customer is choosing seats again, so any existing lock is now stale.
		// Clear it (and its charges) here so BookingSummary reserves a fresh lock
		// and shows the new charges. If the customer instead goes back only to
		// checkout (without coming to this page), the lock and previous charges are
		// left intact and reused.
		sessionStorage.removeItem('lock_id');
		sessionStorage.removeItem('return_lock_id');
		sessionStorage.removeItem('qrcharge');
		sessionStorage.removeItem('facilitycharge');
		sessionStorage.removeItem('handlingcharge');
	}

	render() {
		const returnData = sessionStorageGetItem('returnData');
		// console.log(returnData);
		// console.log(sessionStorageGetItem("departData"));
		const checkReschedule = checkIsReschedule();
		if (sessionStorageGetItem('departData') === null) {
			window.location.href = '/';
		}
		return (
			<>
				<Container>
					<Row>
						<Col lg={7}>
							{/* Rate: { this.state.ConversionRate } */}
							<Proceed_Departure />
							{returnData != null ? <Proceed_Return /> : ''}
							{checkReschedule === false ? (
								<BookingAddOnDeals component='2' />
							) : (
								''
							)}
						</Col>
						<Col lg={5}>
							<Container>
								<div className='proceedBusFare_container'>
									<div className='bus_fare_depart'>
										{/* <h1>Bus Fare</h1> */}
										<ProceedBusFare />
										<AddOn />
										<Row>
											<BusFareTotal page='selectSeat' />
										</Row>
										<Row>
											<SelectSeatButton />
										</Row>
									</div>
									<SelectSeatErrorMsg />
								</div>
							</Container>
						</Col>
					</Row>
				</Container>
			</>
		);
	}
}
export default ProceedComponent;
